<template>
  <div class="docusign-role-list">
    <data-table
      :headers="headers"
      v-model="roles"
      :items-per-page="10"
      filterable
      editable-columns
      title="DocuSign Roles"
    >
      <template v-slot:item.actions="{ item }">
        <loading-icon-button
          @click="openRole(item)"
          tooltip="Edit"
          :loading="progress_indicator.load_role_id == item.id"
        >
          edit
        </loading-icon-button>
        <loading-icon-button
          @click="deleteRoleClicked(item.id)"
          tooltip="Delete DocuSignRole"
          :loading="progress_indicator.load_role_id == item.id"
        >
          clear
        </loading-icon-button>
      </template>
    </data-table>
  </div>
</template>

<script>
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";

export default {
  components: {
    LoadingIconButton,
    DataTable,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: null,
      default: () => null,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "DocuSign Role Name",
          value: "docusign_rolename",
          sort: true,
          width: "200px",
          search: true,
        },
        {
          text: "Zink Name",
          value: "zink_name",
          sort: false,
          search: true,
        },
        {
          text: "Zink Email",
          value: "zink_email",
          sort: true,
          search: true,
        },
        {
          text: "Actions",
          value: "actions",
          align: "right",
          width: "130px",
          optional: false,
        },
      ],
      progress_indicator: {
        load_role_id: false,
      },
    };
  },
  methods: {
    openRole(role) {
      this.$emit("open-role", role);
    },
    deleteRoleClicked(id) {
      this.$emit("delete-role-clicked", id);
    },
  },
  computed: {
    roles() {
      return this.items ?? [];
    },
  },
};
</script>

